import styled from 'styled-components';

const Separator = styled.hr.attrs(() => ({ role: 'separator', ariaOrientation: 'horizontal' }))`
    width: 100%;
    border: none;
    opacity: 0.18;
    margin: ${({ theme }) => `${theme.space.cat} 0`};
    border-bottom: 1px solid ${({ theme }) => theme.name === 'dark' ? theme.colors.blue200 : theme.colors.gray600};
`;

export default Separator;
